import type { Dispatch, RefObject, SetStateAction } from 'react';
import { createContext } from 'react';
import type { CustomControlCode } from '@common/enums';
import type { ProcessActivityContextData } from '@common/formEngine/processActivityContext.types';
import type { DefinedCustomControlData } from '@common/interfaces/customControlData';
import type { HookDataObject } from '@common/interfaces/serviceContext.types';
import type { ValidationErrors } from '@frontend/utils/validation';

export type ProcessActivityEditContextValue<
    Data extends Record<string, unknown> = Record<string, unknown>,
    TCustomControlCode extends CustomControlCode | undefined = undefined,
    Version extends number = 1,
> = Readonly<{
    data: Data;
    errors: ValidationErrors;
    formRef: RefObject<HTMLFormElement>;
    handleCancel: () => Promise<void>;
    onChange: (data: Partial<Data>, validateKeys?: string | string[]) => void;
    processActivityContextData: ProcessActivityContextData<Data, TCustomControlCode, Version>;
    processActivityId?: string;
    setActivityData: Dispatch<SetStateAction<DefinedCustomControlData>>;
    setHookData: Dispatch<SetStateAction<Record<string, HookDataObject<TCustomControlCode, Version>>>>;
    setIsAutoSaveEnabled: Dispatch<SetStateAction<boolean>>;
    setIsUploadingAsset: Dispatch<SetStateAction<boolean>>;
}>;

export const ProcessActivityEditContext = createContext<ProcessActivityEditContextValue | null>(null);
